export default {"src":"/_next/static/media/opportunities-readme-closed.5e701b4c.svg","height":258,"width":81,"blurWidth":0,"blurHeight":0};